import type { Ref } from 'vue';
import { useTimedProgress } from '@/components/home/use-timed-progress';

/**
 * 最初の軸が公開された時点でバーを終えるので、
 * 全軸の完了ではなく最初の軸の公開までにかかる時間を想定する。
 */
const INSIGHTS_EXPECTED_DURATION = { minSec: 30, maxSec: 60 };

export const useInsightsProgress = (source: {
  isGenerating: Ref<boolean>;
  hasError: Ref<boolean>;
  createdAt: Ref<string | undefined>;
  isRestarting?: Ref<boolean>;
}) => useTimedProgress(source, INSIGHTS_EXPECTED_DURATION);
